export const computerMaxThinkingTime = 1000;
